import React, { Component } from "react";
import { Link } from "react-router-dom";

class CartsBlock extends Component {
  render() {
    return (
      <div className="row mx-0 p-0 border rounded14 mb-3">
        <div className="col-12 fw-bolder fs-4 p-3 border-bottom">
          <div className="row mx-0 px-0">
            <div className="col-auto px-1 align-self-center">
              <img
                width="35"
                height="35"
                className={
                  "rounded-circle " +
                  (!this.props.cart.shop.cover
                    ? "p-1 bg-color-main"
                    : "img-cover")
                }
                src={
                  this.props.cart.shop.cover
                    ? this.props.cart.shop.cover.thumbnail
                    : require("../../base/assets/images/logo_white.svg").default
                }
                alt="shop-thumbnail"
              />
            </div>
            <div className="col px-1 align-self-center">
              <p className="fw-bolder mb-0 fs-6">
                {this.props.cart.shop.title}
                {this.props.cart.shop && this.props.cart.shop.is_verify && (
                  <img
                    width="15"
                    className="me-1"
                    alt="verify"
                    src={require("../../base/assets/icons/verify.svg").default}
                  />
                )}
              </p>
            </div>
            <div className="col-auto px-1 align-self-center">
              <p className="fw-bold mb-0 fs-6 text-muted">
                {this.props.cart.total_quantity}
                <span className="me-1">سفارش</span>
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 fw-bolder fs-4 p-3">
          <div className="row mx-0 px-0">
            <div className="col-auto align-self-center px-1">
              <Link to={`/${this.props.cart.shop.uid}/cart`}>
                <button className="btn px-3 rounded28 border color-main fw-bold fs-6">
                  نمایش اطلاعات
                </button>
              </Link>
            </div>
            <div className="col px-1">
              <p className="fs-7 text-muted mb-1" dir="ltr">
                جمع کل
              </p>
              <p className="fs-5 text-start mb-0">
                <span>{this.props.cart.payable_price.title}</span>
                <span className="fs-7 me-1">
                  {this.props.cart.payable_price.currency}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CartsBlock;
